module.exports = __webpack_public_path__ + "img/404.47d84743.png";